import { Component, ChangeDetectionStrategy, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { CheckboxItem } from '../../models/checkbox-treeview-item';
import { FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'checkbox-treeview',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './checkbox-treeview.component.html',
    styleUrls: ['./checkbox-treeview.component.scss'],
    imports: [FormsModule, NgTemplateOutlet, TranslatePipe]
})
export class CheckboxTreeviewComponent implements OnChanges {

    @Input() treeviewData: CheckboxItem[];
    @Input() showFilter?: boolean = false;
    @Input() showOnlyFilter?: boolean = false;
    @Input() showParentsInFilter?: boolean = true;
    @Output() selectedChange = new EventEmitter();

    public treeviewItems: CheckboxItem[] = [];

    public filterText: string;
    public hasFilter: boolean;

    ngOnChanges() {
        this.resetItems();
    }

    /*
     * Set data till grunddata 
     * - & set startinställningar
     */
    private resetItems(): void {
        this.treeviewItems = [];
        Object.assign(this.treeviewItems, this.treeviewData);
        this.setItemsStartSettings();
    }

    /* 
     * Set startinställningar
     * - collapsed
     * - parents
     */
    private setItemsStartSettings(): void {
        this.treeviewItems.forEach(item => {
            this.setParents(item);
        });
    }

    /*
     * Set parents
     * - För att sedan hantera "noneChecked" och someChecked"
     */
    private setParents(item: CheckboxItem, parent?: CheckboxItem) {
        item.parent = parent;
        if (item.children != null) {
            this.parentChildrenControl(item);
            item.children.forEach(childItem => {
                this.setParents(childItem, item);
            });
        }
    }

    /*
     * Sök i både texter och värden
     */
    private filterTreeviewItems: CheckboxItem[] = [];
    public filterChange(): void {
        this.resetItems();
        
        if (this.filterText) {
            this.hasFilter = true;
            this.filterTreeviewItems = [];
            Promise.all([
                this.treeviewItems.forEach(item => { this.itemContainsText(item); })
            ]).then(() => {
                this.treeviewItems = this.filterTreeviewItems;
            });
        } else {
            this.hasFilter = false;
        }
    }
    private itemContainsText(item: CheckboxItem): void {
        if (this.showParentsInFilter || item.children == null) {
            let textContainsFilterText = item.text.toLowerCase().includes(this.filterText.toLowerCase());
            let valueContainsFilterText = item.value.toString().toLowerCase().includes(this.filterText.toLowerCase());
            if (item.value != "all" && (textContainsFilterText || valueContainsFilterText)) {
                this.filterTreeviewItems.push(item);
            }
        }
        if (item.children) {
            item.children.forEach(childItem => {
                this.itemContainsText(childItem);
            });
        }
    }

    /* 
     * Check clicked item
     * - och set sedan parent
     */
    public clickedItem(item): void {
        Promise.all([
            this.CheckboxItem(item)
        ]).then(() => {
            if (item.parent)
                this.parentChildrenControl(item.parent);
        
            this.selectedChange.emit(this.treeviewItems);
        });
    }

    /*
     * Check item & children
     */
    private CheckboxItem(item, parentValue?: boolean): void {            
        let value = parentValue != null ? parentValue : !item.checked;        
        item.checked = value;

        if (item.children) {
            item.someChecked = false; //Sätts senare
            item.noneChecked = value == false;

            item.children.forEach(childItem => {
                this.CheckboxItem(childItem, value);
            })
        }
    }

    /*
     * Check parents 
     * - checked / noneChecked / someChecked
     */
    private parentChildrenControl(parentItem: CheckboxItem): void {
        var allChecked = true, noneChecked = true;
        var oneIsChecked = false, oneUnchecked = false;
        parentItem.children.forEach(child => {
            if (child.checked || child.someChecked) {
                noneChecked = false;
                oneIsChecked = true;
            } else {
                allChecked = false;
                oneUnchecked = true;
            }
            if (oneIsChecked && oneUnchecked)
                return;
        });
        parentItem.checked = allChecked;
        parentItem.noneChecked = noneChecked;
        parentItem.someChecked = oneIsChecked && oneUnchecked && !allChecked && !noneChecked;

        if (parentItem.parent)
            this.parentChildrenControl(parentItem.parent);
    }

}